// import { Language } from '../../services/literals-service'

import { ICountry } from "../../models/country"
import { IBase, IDocument, IPaymentGateway } from "../../models"

export enum UserInfoTypeKeys {
  CHECK_USER = 'CHECK_USER',
  SET_USER_INFO = 'SET_USER_INFO',
  SET_USER_INFO_DNI = 'SET_USER_INFO_DNI',
  SET_USER_INFO_EMAIL = 'SET_USER_INFO_EMAIL',
  SET_USER_INFO_NAME = 'SET_USER_INFO_NAME',
  SET_USER_INFO_LAST_NAME = 'SET_USER_INFO_LAST_NAME',
  SET_USER_INFO_BIRTH_DAY = 'SET_USER_INFO_BIRTH_DAY',
  SET_USER_INFO_BIRTH_MONTH = 'SET_USER_INFO_BIRTH_MONTH',
  SET_USER_INFO_BIRTH_YEAR = 'SET_USER_INFO_BIRTH_YEAR',
  SET_USER_INFO_GENDER = 'SET_USER_INFO_GENDER',
  SET_USER_INFO_IS_PRM = 'SET_USER_INFO_IS_PRM',
  SET_USER_INFO_SETTLEMENT = 'SET_USER_INFO_SETTLEMENT',
  SET_USER_INFO_ADDITIONAL_PHONE = 'SET_USER_INFO_ADDITIONAL_PHONE',
  SET_USER_INFO_ADDITIONAL_PHONE_CALLING_CODE = 'SET_USER_INFO_ADDITIONAL_PHONE_CALLING_CODE',
  SET_USER_INFO_ADDITIONAL_PHONE_COUNTRY = 'SET_USER_INFO_ADDITIONAL_PHONE_COUNTRY',
  SET_IS_USER_PENALIZED = 'SET_IS_USER_PENALIZED',
  SAVE_USER_INFO = 'SAVE_USER_INFO',
  SAVE_USER_LANGUAGE = 'SAVE_USER_LANGUAGE',
  CHANGE_USER_LENGUAGE = 'CHANGE_USER_LENGUAGE',
  SET_NOTIFICATION_FEEDBACK_FLAG = 'SET_NOTIFICATION_FEEDBACK_FLAG',
  CHANGE_CONFIRMATION_FLAG = 'CHANGE_CONFIRMATION_FLAG',
  IS_LOADING_USER_INFO = 'IS_LOADING_USER_INFO',
  SET_IS_USER_EXPERIENCED = 'SET_IS_USER_EXPERIENCED',
  SET_PAYMENT_METHOD_ID = 'SET_PAYMENT_METHOD_ID',
  SET_STRIPE_CUSTOMER_IDS = 'SET_STRIPE_CUSTOMER_IDS',
  SET_ACCOUNT_ID = 'SET_ACCOUNT_ID',
  SET_PAYMENT_GATEWAY = 'SET_PAYMENT_GATEWAY',
  SET_TOWN = 'SET_TOWN',
  SET_GUEST_MODE = 'SET_GUEST_MODE',
  SHOW_GUEST_SIGN_UP = 'SHOW_GUEST_SIGN_UP',
  HIDE_GUEST_SIGN_UP = 'HIDE_GUEST_SIGN_UP',
  SET_GUEST_SIGN_UP_SCREEN = 'SET_GUEST_SIGN_UP_SCREEN',
  SET_DOCUMENTS = 'SET_DOCUMENTS',
  FETCH_DOCUMENTS = 'FETCH_DOCUMENTS',
  UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT',
  DELETE_DOCUMENT = 'DELETE_DOCUMENT'
}

export interface ICheckSessionAction {
  type: UserInfoTypeKeys.CHECK_USER
  [extraProps: string]: unknown
}

export interface ISetUserInfoAction {
  type: UserInfoTypeKeys.SET_USER_INFO
  payload: any
  [extraProps: string]: unknown
}

export interface ISetUserInfoDNIAction {
  type: UserInfoTypeKeys.SET_USER_INFO_DNI
  payload: string
  [extraProps: string]: unknown
}

export interface ISetUserInfoEmailAction {
  type: UserInfoTypeKeys.SET_USER_INFO_EMAIL
  payload: string
  [extraProps: string]: unknown
}

export interface ISetUserInfoNameAction {
  type: UserInfoTypeKeys.SET_USER_INFO_NAME
  payload: string
  [extraProps: string]: unknown
}

export interface ISetUserInfoLastNameAction {
  type: UserInfoTypeKeys.SET_USER_INFO_LAST_NAME
  payload: string
  [extraProps: string]: unknown
}

export interface ISetUserInfoBirthDayAction {
  type: UserInfoTypeKeys.SET_USER_INFO_BIRTH_DAY
  payload: string
}

export interface ISetUserInfoBirthMonthAction {
  type: UserInfoTypeKeys.SET_USER_INFO_BIRTH_MONTH
  payload: string
}

export interface ISetUserInfoBirthYearAction {
  type: UserInfoTypeKeys.SET_USER_INFO_BIRTH_YEAR
  payload: string
}

export interface ISetUserInfoGenderAction {
  type: UserInfoTypeKeys.SET_USER_INFO_GENDER
  payload: string
}

export interface ISetUserInfoIsPrmAction {
  type: UserInfoTypeKeys.SET_USER_INFO_IS_PRM
  payload: boolean
}

export interface ISetUserInfoSettlementAction {
  type: UserInfoTypeKeys.SET_USER_INFO_SETTLEMENT
  payload: string
}

export interface ISetUserInfoAdditionalPhoneAction {
  type: UserInfoTypeKeys.SET_USER_INFO_ADDITIONAL_PHONE
  payload: string
}

export interface ISetUserInfoAdditionalPhoneCallingCodeAction {
  type: UserInfoTypeKeys.SET_USER_INFO_ADDITIONAL_PHONE_CALLING_CODE
  payload: string
}

export interface ISetUserInfoAdditionalPhoneCountryAction {
  type: UserInfoTypeKeys.SET_USER_INFO_ADDITIONAL_PHONE_COUNTRY
  payload: ICountry
}

export interface ISaveUserInfoAction {
  type: UserInfoTypeKeys.SAVE_USER_INFO
  [extraProps: string]: unknown
}

export interface ISaveUserLanguageAction {
  type: UserInfoTypeKeys.SAVE_USER_LANGUAGE
  payload: string
  [extraProps: string]: unknown
}

export interface IChangeUserLanguageAction {
  type: UserInfoTypeKeys.CHANGE_USER_LENGUAGE
  payload: string
  [extraProps: string]: unknown
}

export interface ISetNotificationFeedbackFlagAction {
  type: UserInfoTypeKeys.SET_NOTIFICATION_FEEDBACK_FLAG
  payload: boolean
  [extraProps: string]: unknown
}

export interface IChangeConfirmationFlagAction {
  type: UserInfoTypeKeys.CHANGE_CONFIRMATION_FLAG
  [extraProps: string]: unknown
}

export interface ISetIsUserPenalizedAction {
  type: UserInfoTypeKeys.SET_IS_USER_PENALIZED
  [extraProps: string]: unknown
}

export interface ISetIsLoadingUserInfoAction {
  type: UserInfoTypeKeys.IS_LOADING_USER_INFO
  payload: boolean
  [extraProps: string]: unknown
}

export interface ISetIsUserExperienced {
  type: UserInfoTypeKeys.SET_IS_USER_EXPERIENCED
  payload: boolean
}

export interface ISetPaymentMethodId {
  type: UserInfoTypeKeys.SET_PAYMENT_METHOD_ID
  payload: string
}

export interface ISetStripeCustomerIds {
  type: UserInfoTypeKeys.SET_STRIPE_CUSTOMER_IDS
  payload: any[]
}

export interface ISetAccountId {
  type: UserInfoTypeKeys.SET_ACCOUNT_ID
  payload: string
  [extraProps: string]: unknown;
}

export interface ISetPaymentGatewayAction {
  type: UserInfoTypeKeys.SET_PAYMENT_GATEWAY
  payload: IPaymentGateway
}

export interface ISetTownAction {
  type: UserInfoTypeKeys.SET_TOWN
  payload: IBase
  [extraProps: string]: unknown
}

export interface ISetGuestModeAction {
  type: UserInfoTypeKeys.SET_GUEST_MODE
}

// The screens the guest prompt can show: the choice screen, the login, the three sign up steps,
// the recover password / verification flows the login links to, and the new password a temporary
// one asks for.
export type GuestSignUpScreen =
  | 'intro' | 'signIn' | 'signUp1' | 'signUp2' | 'signUp3'
  | 'recoverRequest' | 'recoverRestore' | 'verification' | 'verificationResend' | 'newPassword'

export interface IShowGuestSignUpAction {
  type: UserInfoTypeKeys.SHOW_GUEST_SIGN_UP
  payload: GuestSignUpScreen
}

export interface ISetGuestSignUpScreenAction {
  type: UserInfoTypeKeys.SET_GUEST_SIGN_UP_SCREEN
  payload: GuestSignUpScreen
}

export interface IHideGuestSignUpAction {
  type: UserInfoTypeKeys.HIDE_GUEST_SIGN_UP
}

export interface ISetDocumentsAction {
  type: UserInfoTypeKeys.SET_DOCUMENTS
  payload: IDocument[]
}

export interface IFetchDocumentsAction {
  type: UserInfoTypeKeys.FETCH_DOCUMENTS
}

export interface IUploadDocumentAction {
  type: UserInfoTypeKeys.UPLOAD_DOCUMENT
  payload: { image: string, type: string, fileName: string }
}

export interface IDeleteDocumentAction {
  type: UserInfoTypeKeys.DELETE_DOCUMENT
  payload: number
}

export type UserInfoActionTypes =
  | ICheckSessionAction
  | ISetUserInfoAction
  | ISetUserInfoDNIAction
  | ISetUserInfoEmailAction
  | ISetUserInfoNameAction
  | ISetUserInfoLastNameAction
  | ISetUserInfoBirthDayAction
  | ISetUserInfoBirthMonthAction
  | ISetUserInfoBirthYearAction
  | ISetUserInfoGenderAction
  | ISetUserInfoIsPrmAction
  | ISetUserInfoSettlementAction
  | ISetUserInfoAdditionalPhoneAction
  | ISetUserInfoAdditionalPhoneCallingCodeAction
  | ISetUserInfoAdditionalPhoneCountryAction
  | ISaveUserInfoAction
  | IChangeUserLanguageAction
  | ISetNotificationFeedbackFlagAction
  | IChangeConfirmationFlagAction
  | ISetIsUserPenalizedAction
  | ISetIsLoadingUserInfoAction
  | ISetIsUserExperienced
  | ISetPaymentMethodId
  | ISetStripeCustomerIds
  | ISetAccountId
  | ISetPaymentGatewayAction
  | ISetTownAction
  | ISetGuestModeAction
  | IShowGuestSignUpAction
  | IHideGuestSignUpAction
  | ISetGuestSignUpScreenAction
  | ISetDocumentsAction
  | IFetchDocumentsAction
  | IUploadDocumentAction
  | IDeleteDocumentAction
